import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  mfaOtp: [],
  isLoadingMfaOtp: false,
  base64String: "",
  checkOtp: [],
  isLoadingCheckOtp: false,
  isOtpLoaded: false,
  isOtpVerified: false,
};

// getOTP for Asset Configurations

export const getMfaOtp: any = createAsyncThunk(
  "content/getMfaOtp",
  async () => {
    const res = await axios.get(`/slpapp/Mfa/getotp`);
    const data = await res.data;

    return data;
  }
);

// checkOTP for Asset Configuration
export const checkMfaOtp: any = createAsyncThunk(
  "content/checkMfaOtp",
  async ({ code }: any) => {
    const res = await axios.post(
      `/slpapp/Mfa/checkotp`,
      {},
      {
        params: {
          code,
        },
      }
    );
    const data = await res.data;

    return data;
  }
);

export const otpSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {
    setOtpIsValidation: (state, action) => {
      state.isOtpVerified = action.payload;
      state.isOtpLoaded = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMfaOtp.pending, (state) => {
      state.isLoadingMfaOtp = true;
    });
    builder.addCase(getMfaOtp.fulfilled, (state, action) => {
      state.base64String = action.payload;
      state.isLoadingMfaOtp = false;
    });
    builder.addCase(getMfaOtp.rejected, (state, action) => {
      state.isLoadingMfaOtp = false;
      state.error = action.error.message;
    });

    builder.addCase(checkMfaOtp.pending, (state) => {
      state.isLoadingCheckOtp = true;
    });
    builder.addCase(checkMfaOtp.fulfilled, (state, action) => {
      state.isLoadingCheckOtp = false;
      state.isOtpLoaded = true;
      state.isOtpVerified = action.payload;
    });
    builder.addCase(checkMfaOtp.rejected, (state, action) => {
      state.isLoadingCheckOtp = false;
      state.error = action.error.message;
    });
  },
});

export const { setOtpIsValidation } = otpSlice.actions;

export default otpSlice.reducer;
